import React, { Component } from 'react';
import { Col, Row, Container } from 'reactstrap';
import ProductCard from './components/ProductCard';
// import RelatedItems from './components/RelatedItems';
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { loadProducts } from '../../../redux/actions/productActions'
import { GetProducts } from '../../../queries/products'
import { withApollo } from 'react-apollo';
import { loader as Loader } from '../../Loader';

class ProductPage extends Component {
  state = {
    product: null,
    relatedItems: [],
    loadingProduct: true
  };

  componentDidUpdate (prevProps, prevState) {
    return !this.state.product ? this.getProduct() : null;
  }

  componentDidMount () {
    this.getProduct()
    //return !this.state.product ? this.getProduct() : null
  }

  async getProduct () {
    const currentProductID = this.props.match.params.tag;

    try {
      let product = null
      if (this.props.products) {
        product = this.props.products.find(product => {
          return product.productID === currentProductID
        })
      } else {
        //get products from query
        const { data: productData } = await this.props.client.query({
          query: GetProducts(),
          fetchPolicy: 'network-only'
        })
        this.props.loadProducts(productData.listProducts.items)
        product = productData.listProducts.items.find(product => {
          return product.productID === currentProductID
        })
      }

      if (product) {
        this.setState({ product, loadingProduct: false });
      } else {
        this.setState({ loadingProduct: false });
      }

    } catch (err) {
      console.log(err.message)
      this.setState({ loadingProduct: false });
      // this.props.history.push('/app/404')
    }
  }

  render () {
    return (
      <Container style={{ paddingLeft: '40px', paddingRight: '40px' }}>

        <div className="product-container">
          {
            this.state.loadingProduct ?
              <Loader /> :
              <React.Fragment>
                <Row>
                  <Col md={12}>
                    {/* <h3 className='page-title'>Product Page</h3> */}
                    <button className='btn btn-secondary'
                      onClick={() => {
                        this.props.history.push('/app/marketplace');
                      }}
                      style={{
                        float: 'left'
                      }}>{"<< Back To Marketplace"}</button>
                  </Col>
                </Row>
                <Row>
                  <ProductCard currentProduct={this.state.product} />
                </Row>
              </React.Fragment>
          }
          {/* <Row>
          <Col md={12}>
            <h3 className='page-title page-title--not-last'>Related Items</h3>
          </Col>
        </Row>
        <Row>
          <RelatedItems relatedItems={this.state.relatedItems} />
        </Row> */}
        </div>

      </Container>
    )
  }
}

function mapStateToProps (state) {
  return {
    products: state.productsData ? state.productsData.products : null
  }
}

export default withRouter(withApollo(connect(mapStateToProps, { loadProducts })(ProductPage)));



// WEBPACK FOOTER //
// ./src/components/e-commerce/product_page/ProductPage.js